/**
 * Created by olga on 01.07.2025
 */

const TaskIcon = cc.Scale9Sprite.extend({
    ctor: function (homefixIdComponent, onClick) {
        this.homefixIdComponent = homefixIdComponent;
        this.furniture = homefixIdComponent.furniture;

        this._super(bundles.homefix.frames.task_icon_png);

        const styles = cleverapps.styles.Taskicon;
        this.pointer = new cc.Sprite(bundles.homefix.frames.task_icon_pointer_png);
        this.pointer.setAlignment(styles.pointer);
        this.addChild(this.pointer);

        const unitIcon = this.createUnitIcon();
        const description = this.createDescription();
        this.progressBar = this.createProgressBar();

        const descriptionLayout = new cleverapps.Layout([description, this.progressBar], {
            margin: styles.marginY,
            direction: cleverapps.UI.VERTICAL
        });

        this.content = new cleverapps.Layout([unitIcon, descriptionLayout], {
            margin: styles.marginX,
            direction: cleverapps.UI.HORIZONTAL,
            padding: styles.padding
        });

        this.setContentSize(this.content.getContentSize());
        this.content.setAlignment({ align: "center" }, { align: "center" });
        this.addChild(this.content);

        this.updateReady();

        this.setAlignment({ align: "center" }, { align: "top", dy: this.height / 2 + styles.unitOffset });

        cleverapps.UI.onClick(this, () => {
            cleverapps.effects.fire("ui.button.click");
            onClick();
        });
    },

    updateReady: function (animated) {
        const isReady = this.furniture.canBeUpgraded();
        this.setSpriteFrame(isReady ? bundles.homefix.frames.task_icon_ready_png : bundles.homefix.frames.task_icon_png);
        this.pointer.setSpriteFrame(isReady ? bundles.homefix.frames.task_icon_pointer_ready_png : bundles.homefix.frames.task_icon_pointer_png);
        this.progressBar.setPercentage(this.furniture.getReadyPercent(), {
            animated
        });
    },

    createUnitIcon: function () {
        const styles = cleverapps.styles.Taskicon.unitIcon;
        const view = UnitView.getUnitImage({
            code: this.homefixIdComponent.unit.code,
            stage: this.homefixIdComponent.unit.isLast() ? this.homefixIdComponent.unit.stage : this.homefixIdComponent.unit.stage + 1
        });

        cleverapps.UI.fitToBox(view, { width: styles.width, height: styles.height });
        view.setAnchorPoint(0.5, 0.5);
        return view;
    },

    createDescription: function () {
        const styles = cleverapps.styles.Taskicon.description;
        const text = cleverapps.UI.generateOnlyText(Messages.get(this.furniture.getInfo().dialogue), cleverapps.styles.FONTS.TASK_ICON_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.width, 0);
        text.fitTo(undefined, styles.height);
        return text;
    },

    createProgressBar: function () {
        const styles = cleverapps.styles.Taskicon.progressBar;
        const availableStars = cleverapps.meta.getSelectedLocation().stars;
        const cost = this.furniture.getInfo().cost;
        const bar = new ScaledProgressBar({
            from: Math.min(availableStars, cost),
            to: cost,
            barText: {
                text: "%from%/%to% %%",
                icons: {
                    "%%": bundles.reward_icons.frames.simple_star_png
                }
            },
            progress: bundles.progress_bar.frames.task_icon_bar,
            background: bundles.progress_bar.frames.task_icon_bar_bg
        });
        bar.setLength(styles.width);

        return bar;
    }

});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TASK_ICON_TEXT: {
        size: 30,
        color: new cc.Color(82, 142, 24)
    }
});

cleverapps.styles.Taskicon = {
    unitOffset: 25,
    pointer: {
        x: { align: "center" },
        y: -5
    },

    marginX: 30,
    marginY: 20,
    padding: {
        x: 35,
        top: 20,
        bottom: 37
    },

    unitIcon: {
        width: 100,
        height: 100
    },

    description: {
        width: 210,
        height: 100
    },

    progressBar: {
        width: 230
    }
};